export const AR_QUALIFICATION_CHECK_TEXT = {
  APPLICANT_PARTICULARS: 'Applicant Particulars',
  QUALIFICATION_CHECK: 'Qualification Check',
  WILL_UPDATE: 'Will Update',
  OUT_OF: 'out of',
  NA: 'N/A',
  UNNAMED: 'Unnamed',
  COMPLETED: 'Completed',
  NOT_YET_COMPLETED: 'Not Yet Completed',
  WAIVED: 'Waived',
  REQUIRED: 'Required',
  VISA_APPLICATION: 'Visa Application',
  SAVE: 'Save',
};

export const QUALIFICATION_PAGE_TEXT = {
  TITLE: 'Qualification Check',
  BASIC_INFORMATION: 'Applicant Basic Information',
  ACADEMIC_CHECK: 'Academic Qualification Check',
  LANGUAGE_CHECK: 'Language Qualification Check',
  OTHER_CHECK: 'Other Tests Qualification Check',
  AR_HOME_PAGE_TEXT: {
    QUALIFICATION_CHECK: 'Qualification Check',
    VISA_APPLICATION: 'Visa Application',
    REGISTRATION_CARD: 'Student Card Collection',
  },
  EXPORT: 'Export Visa Information',
  VERIFICATION_CODE_TIP_TEXT:
    'For degrees awarded by universities in Mainland China and recognized ' +
    'by the Ministry of Education of the Chinese Mainland, the Online Verification Code (線上驗證碼) ' +
    'issued by the China Academic Degrees & Graduate Education Development Center (教育部學位與研究生教育發展中心) ' +
    'is required.',
  LANGUAGE: 'Language Qualification',
  OTHER_TEST: 'Other Test Qualification',
  CERTIFICATE: 'Certificate(s)',
  CODES: 'Online Verification Code(s)',
  TRANSCRIPT: 'Latest Transcript(s)/Official Proof',
  MARK_EXPLANATION: 'Explanatory Notes of the Marking Scheme/Grading System',
  CLASS_RANKING_PROOF: 'Class Ranking Proof',
  OTHER_DOCUMENTS: 'Other Documents',
  FILE: 'File:',
  NA: 'N/A',
  REMARKS: 'Remarks (for internal use)',
  BATCH_UPLOAD_TEXT: {
    TITLE: 'Batch Visa Information Upload',
    UPLOAD_REMARK:
      'Upload remark: Only accept one CSV file without any password or encryption.',
    REF_NO: 'Ref.No',
    APPLICATION_NO: 'Application.No',
    BATCH_UPLOAD: 'Batch Upload',
    CSV_TEMPLATE: 'Download CSV Template',
    NON_MATCHED: 'Non-matched',
    RESOLVED_RESULT: 'Resolved Result',
    IMMD_OFFICER: 'IMMD Officer in Charge',
    VISA_LABEL_APPROVAL_DATE: 'Visa Label Approval Date',
    APPLICATION_RECEIVED_DATE: 'Application Received Date',
    SUBMISSION_DATE_TO_IMMD: 'Submission Date to IMMD',
  },
  ALERT_MESSAGE: {
    SAVED_SUCCESSFULLY: 'Saved Qualification Check Successfully.',
    RELEASED_SUCCESSFULLY: 'Released Qualification Check Successfully.',
    SAVE_FAILED: 'Saved Qualification Check Failed.',
  },
  VISA_DETAIL_TEXT: {
    TITLE: 'Visa Detail',
    ENTRY_SLIP: 'Entry Slip:',
    VISA_DOC: 'Visa Document:',
    NA: 'N/A',
  },
  TRUE: 'True',
  FALSE: 'False',
  CLOSE: 'Close',
  IMPORT: 'Import',
  SAVE: 'Save',
  RELEASE: 'Save & Release',
};

export const AR_LIST_TEXT = {
  APPLICATION_NO: 'Application No.',
  APPLICANT_NAME: 'Applicant Name',
  APPLICANT_EMAIL: 'Applicant Email',
  PROG_TYPE: 'Prog.Type',
  PROG_CODE: 'Prog.Code',
  ENTRY_YEAR: 'Entry Year',
  NATIONALITY: 'Country/Region',
  VISA_REF: 'Visa Ref No.',
  APPLICATION_RECEIVED_DATE: 'Application Received Date',
  SUBMISSION_DATE_TO_IMMD: 'Submission Date to IMMD',
  VISA_LABEL_APPROVAL_DATE: 'Visa Label Approval Date',
  VISA_STATUS: 'Visa Status',
  STATUS: 'Status',
  ACTION: 'Action',
  EXPORT_TEXT: {
    QUALIFICATION_CHECK: 'Export Qualification Check',
    VERIFICATION_STATUS: 'Export Verification Status',
  },
  RELEASED: 'Released',
};

export const VISA_STATUS_TEXT = {
  PENDING_APPLICATION_SUBMISSION: 'Pending Application Submission',
  APPLICATION_RECEIVED: 'Application Received',
  PROCESSING: 'Processing',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  ACTIVATED: 'Activated',
};

export const VISA_STATUS_HELPER_TEXT = {
  PENDING_APPLICATION_SUBMISSION:
    'You have accepted the offer and need to complete your visa application',
  APPLICATION_RECEIVED: 'Your visa application materials have been received',
  PROCESSING: 'Your application is under review by Hong Kong Immigration',
  APPROVED: 'Your visa application has been approved',
  REJECTED: 'Your visa application has been rejected',
  ACTIVATED: 'Your visa application has been activated',
};

export const REGISTRATION_CARD_TEXT = {
  SUBTITLE: 'Student Card Collection Schedule',
  AM: 'AM · ',
  PM: 'PM · ',
  QUOTA: 'Available Quotas:',
  APP_NO: 'Application No.',
  STUDENT_NO: 'Student No.',
  STUDENT_NAME: 'Student Name',
  INDEX: '#',
};
